import { createRouter, createWebHashHistory } from 'vue-router'

// 异常路由页
const errorRoutes = [
  { path: '/loadingPage', component: () => import('@/pages/loading-page.vue') },
  { path: '/failPage', component: () => import('@/pages/fail-page.vue') },
  { path: '/:path(.*)', component: () => import('@/pages/not-found.vue') }
]
const defaultRoutes = [
  { path: '/', component: () => import('@/pages/inviteActivity/index.vue') },
  {
    path: '/share',
    component: () => import('@/pages/inviteActivity/share.vue')
  }
]
const routes = [...defaultRoutes, ...errorRoutes]

console.log('routes>>', routes)

const router = createRouter({
  history: createWebHashHistory(import.meta.env.VITE_BASE_URL),
  routes
})
export default router
